import type {SetPanelOpenType} from '@github-ui/code-view-shared/contexts/OpenPanelContext'
import type {PanelType, TocEntry} from '@github-ui/code-view-types'
import {ListUnorderedIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'
import React from 'react'

export default function TableOfContents({
  toc,
  openPanel,
  setOpenPanel,
  isDirectoryReadme,
}: {
  toc: TocEntry[] | null
  openPanel?: PanelType | undefined
  setOpenPanel?: SetPanelOpenType
  isDirectoryReadme?: boolean
}) {
  const ref = React.useRef<HTMLButtonElement>(null)
  return showToc(toc) ? (
    // eslint-disable-next-line primer-react/a11y-remove-disable-tooltip
    <IconButton
      unsafeDisableTooltip
      ref={ref}
      sx={{color: 'var(--fgColor-muted, var(--color-fg-muted))', mr: isDirectoryReadme ? 0 : 2}}
      icon={ListUnorderedIcon}
      variant="invisible"
      aria-label="Outline"
      aria-pressed={openPanel === 'toc'}
      onClick={() => {
        setOpenPanel?.(openPanel === 'toc' ? undefined : 'toc', ref.current)
      }}
      size="small"
    />
  ) : null
}

function showToc(toc: TocEntry[] | null) {
  return toc && toc.length >= 2
}

try{ TableOfContents.displayName ||= 'TableOfContents' } catch {}